
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const noteApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listNotes: builder.query ({
      query: (params) => `v2/note/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),
    getNote: builder.query ({
      query: (note_id) => `v2/note/${note_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["Note"]
    }),

    updateNote: builder.mutation ({
      query: ({note_id, data}) => ({
        url: `v2/note/${note_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["Note"]
    }),
    deleteNote: builder.mutation ({
      query: (note_id) => ({
        url: `v2/note/${note_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["Note"]
    }),
    createNote: builder.mutation ({
      query: (data) => ({
        url: `v2/note/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["Note"]
    }),
  })
})


export const {
  useListNotesQuery,
  useLazyListNotesQuery,
  useGetNoteQuery,
  useLazyGetNoteQuery,

  useUpdateNoteMutation,
  useDeleteNoteMutation,
  useCreateNoteMutation
} = noteApi
